var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(_vm.$vuetify.breakpoint.mdAndDown)?_c('AppNavBarBottom'):_vm._e(),(_vm.$vuetify.breakpoint.lgAndUp)?_c('AppNavBarSide'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }